import React from "react";
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
  DotGroup,
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import _ from "lodash";
import ZoomCards from "./ZoomCards";

const ZoomBatchCarousel = ({
  batchdata,
  setBatchData,
  selectedStudents,
  setSelectedStudents,
  batchStudentsData,
}) => {
  return (
    <CarouselProvider
      naturalSlideWidth={100}
      naturalSlideHeight={100}
      totalSlides={Object.keys(batchdata).length}
      visibleSlides={3}
      className="zoomBatchCarouselContainer"
    >
      <Slider id="zoomBatchCarouselSlider">
        {_.map(
          Object.keys(batchdata),
          (batch, index) =>
            Object.keys(batchdata[batch]).length > 0 && (
              <Slide key={index} index={index} id="zoomBatchCarouselSlide">
                <ZoomCards
                  studentsData={batchdata[batch]}
                  batch={batch}
                  setBatchStudents={setBatchData}
                  selectedStudents={selectedStudents}
                  setSelectedStudents={setSelectedStudents}
                  batchStudentsData={batchStudentsData}
                />
              </Slide>
            )
        )}
      </Slider>
      <div className="zoomBatchCarouselControls">
        <div className="zoomBatchCarouselControlsSec">
          <ButtonBack className="zoomBatchCarouselBtn">
            <svg
              className="zoomBatchCarouselLeftBtn"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 18L9 12L15 6"
                stroke="#D0D5DD"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </ButtonBack>
          <DotGroup className="zoomBatchCarouselDots" />
          <ButtonNext className="zoomBatchCarouselBtn">
            <svg
              className="zoomBatchCarouselRightBtn"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 6L15 12L9 18"
                stroke="#667085"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </ButtonNext>
        </div>
      </div>
    </CarouselProvider>
  );
};

export default ZoomBatchCarousel;
